import styled from 'styled-components'

const Badge = styled.div<{ index: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: #1c1c1c;
  border-radius: 50%;
  height: 40px;
  width: 30px;
  position: relative;
  z-index: ${(props) => props.index};

  // xlarge desktop
  @media (min-width: 80em) {
    height: 46px;
    width: 36px;
  }
`

const Image = styled.img`
  border-radius: 50%;
  object-fit: cover;
  z-index: 6;
  height: 34px;
  min-width: 34px;
  position: absolute;
  display: inline-block;
  top: 0;
  border: 3px solid #1c1c1e;
  left: 0;

  // xlarge desktop
  @media (min-width: 80em) {
    height: 40px;
    min-width: 40px;
  }
`

const Container = styled.div`
  display: flex;
  align-items: center;
  color: white;
  font-size: 18px;
  font-weight: bold;
  height: 48px;
  border-radius: 30px;
  padding: 0 24px;
  background: linear-gradient(90deg, #000000 0%, #161616 100%);

  // tablet
  @media (min-width: 80em) {
    height: 60px;
  }
`

const SupportedBy = styled.div`
  margin-right: 12px;
  font-size: 1rem;

  // small mobile
  @media (max-width: 30em) {
    font-size: 0.75rem;
  }
`

const SupportorBadge = ({ index }: { index: number }): JSX.Element | null => {
  return (
    <Badge index={index}>
      <Image src={'https://arweave.net/mweSkx5QwDdV6c513VHHRj2TiGnXPXKhms1gLrfjMEY'} />
    </Badge>
  )
}

// eslint-disable-next-line react/display-name
const Supportors = (): JSX.Element => (
  <Container>
    <SupportedBy>Supported by</SupportedBy>
    {[1, 2, 3, 4, 5].map((index) => (
      <SupportorBadge key={index} index={6 - index} />
    ))}
  </Container>
)

export default Supportors
